import React from 'react'
import { FormContextProvider } from '../../../../../context/formContext'
import Toast from '../../../../../components/Toast/Toast'
import ViewFormsSent from './ViewFormsSent'
const ConsultaFormWrapper = () => {
  return (
    <FormContextProvider>
      <Toast />
      <ViewFormsSent />
    </FormContextProvider>
  )
}

export default ConsultaFormWrapper
